import * as types from "../../mutation-types";
import {removeItem, addOrUpdateItem} from "../../helpers";

export default {
    [types.ADD_OR_UPDATE_SUBSCRIBED_CONTACT]: (state, item) => addOrUpdateItem(state, item, ['reference_type', 'reference_id', 'contact_id']),
    [types.REMOVE_SUBSCRIBED_CONTACT]: (state, item) => removeItem(state, item, ['reference_type', 'reference_id', 'contact_id'])
}
